export type FormattedActionType<K extends string, T extends string> = `@@${K}/${T}`;

const formatActionType = <K extends string, T extends string>({ key, type }: { key: K; type: T }) =>
  `@@${key}/${type}` as const;

export default formatActionType;
